import {
    CREATE_EDIT_SCHEDULED_ACTION_OPEN_MODAL,
    CREATE_EDIT_SCHEDULED_ACTION_REQUEST,
    CREATE_EDIT_SCHEDULED_ACTION_RESULT,
    CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_REQUEST,
    CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_RESULT,
} from 'Redux/actionTypes';


export const createEditScheduledActionOpenModal = (open, id) => ({
    type: CREATE_EDIT_SCHEDULED_ACTION_OPEN_MODAL,
    payload: { open, id }
})

export const createEditScheduledActionRequest = (data) => ({
    type: CREATE_EDIT_SCHEDULED_ACTION_REQUEST,
    payload: data
})

export const createEditScheduledActionResult = (result) => ({
    type: CREATE_EDIT_SCHEDULED_ACTION_RESULT,
    payload: result
})

export const createEditScheduledActionGetDetailRequest = (data) => ({
    type: CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_REQUEST,
    payload: data
})

export const createEditScheduledActionGetDetailResult = (data) => ({
    type: CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_RESULT,
    payload: data
})